module.exports = __webpack_public_path__ + "img/logo.07a03e5b.svg";